/*@ngInject*/
const EmailNotificationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

        this.loadEmailNotificationActions = function () {
            var url = '/rest/Actions',
                config = {
                    params: {
                        uri: 'com.firstbest.underwriting.notification.NotificationEmailTemplate'
                    }
                };

        return this.get(url, config);
    };

    this.loadEmailNotification = function (requestParams) {
        var url = '/rest/NotificationEmailTemplate',
            config = {
                params: {
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize,
                    searchString: requestParams.searchString
                }
            };
        return this.get(url, config);
    }

        this.loadRecipients = function() {
            var url = '/rest/User/recipients';
            return this.get(url);
        }

    };

angular.module('ums.configuration')
    .service('emailNotificationRepository', EmailNotificationRepository);
